<template>
  <div
    class="conversation-recipient row v-middle gx-0"
    :class="{
      'closed-conversation': conversation.status === 'closed'
    }"
  >
    <div
      :class="`phone-label-${conversationId} gx-0 row pr-1 border-top border-bottom ${toggleSelected ? 'bg-danger' : 'bg-secondary'} bg-gradient`"
    >
      <div :title="`${conversation.channel == 'media' ? conversation.resource_file : conversation.primary_recipient}`"
        :class="`${conversation.channel == 'media' ? 'col-12 text-truncate' : 'col-8'} py-1 fs-2 d-block text-left fw-bold text-white pl-2`">
        {{
          conversation.channel == 'media'
            ? splitFilename(conversation.resource_file)
            : (conversation.source ? conversation.source : prettyPhoneNumber(conversation.number))
        }}
      </div>
      <div class="col-4 pr-2 py-1 fs-2 d-block mt-0 text-right fw-bold text-white" v-if="conversation.channel != 'media'">
        <i>{{ conversation.direction === "inbound" ? "Inbound" : "Outbound" }}</i>
      </div>
    </div>
    <div :class="`row pt-1 pb-1 gx-0 ${toggleSelected ? 'convo-selected' : ''
      }`">
      <div class="row pl-2 pb-2 gx-0">
        <div class="fs-2 fw-normal text-muted col-9">
          {{ conversation.operator_name }}
          <b-icon v-if="agentOnline" icon="dot" variant="success" scale="4" title="Agent online" />
        </div>
        <div class="col-3 text-right pr-3">
          <span v-if="hasLocation">
            <b-icon icon="pin-map-fill" variant="info" title="Location received" />
          </span>
          <span v-if="hasVideoSession" class="pl-2">
            <b-icon icon="camera-video-fill" variant="success" :animation="`${hasVideoParticipants ? 'fade' : ''}`"
              title="Active Video Session" />
          </span>
        </div>
      </div>
      <div class="col-3 h2 text-center">
        <span class="pl-2">
          <b-icon icon="chat-left-text" v-if="conversation.channel == 'sms'" />
          <b-icon icon="telephone" v-if="conversation.channel == 'voice'" />
          <b-icon icon="chat-text" v-if="conversation.channel == 'web'" />
          <b-icon icon="file-earmark-play" v-if="conversation.channel == 'media'" />
        </span>
      </div>
      <div class="col-9 pr-3 pl-3">
        <h5 class="message-title fs-3 fw-bold text-right">
          <div class="mb-2">
            {{ conversation.label ? prettyRecipientLabel(conversation.label) :
              prettyPhoneNumber(conversation.primary_recipient) }}
            <div class="fs-2 fw-normal text-muted font-italic mt-1 text-nowrap" style="position: relative">
              {{ formatTimestamp(conversation.last_message_at ? conversation.last_message_at : conversation.updated_at,
                "fromnow") }}
            </div>
          </div>
        </h5>
      </div>
    </div>
    <div v-if="conversation.recent_message" :class="`row gx-0 px-2 pb-2 ${toggleSelected ? 'convo-selected' : ''}`">
      <div class="d-block time text-truncate fw-normal text-left">
        <b-icon-pin-map-fill scale="1" v-if="conversation.recent_message == 'Location Received'" class="mr-2 ml-2" />
        {{ truncatedRecentMessage }}
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapState } from "vuex";
import { EventBus } from "../../events/eventBus";
import formatter from "../../mixins/formatter";

export default {
  name: "ConversationRecipient",
  mixins: [formatter],
  props: {
    conversation: Object,
  },
  data() {
    return {
      receiveGeolocation: false,
    };
  },
  computed: {
    ...mapGetters("agency", ["agencySettings", "availableAgents"]),
    ...mapGetters("video", ["videoRooms"]),
    ...mapState({
      conversations: (state) => state.conversations.conversations
    }),
    conversationId() {
      return this.conversation.conversation_id;
    },
    internationalDialCodeEnabled() {
      return this.agencySettings.enableInternational == "true";
    },
    hasVideoParticipants() {
      const videoRoom = this.videoRooms.find(room => {
        return room.conversation_id === this.conversationId && room.status === "in-progress";
      });
      return videoRoom && videoRoom.participants && videoRoom.participants.length > 0;
    },
    hasVideoSession() {
      const videoRoom = this.videoRooms.find(room => {
        return room.conversation_id === this.conversationId && room.status === "in-progress";
      });
      return !!videoRoom;
    },
    hasLocation() {
      const currentConversation = this.conversations.find((c) => c.conversation_id === this.conversationId);
      return (currentConversation && currentConversation.latest_geography) || this.receiveGeolocation;
    },
    toggleSelected() {
      return this.$route.name === "Conversation Detail" && this.$route.params.conversationId === this.conversationId;
    },
    truncatedRecentMessage() {
      return `${this.conversation.recent_message.slice(0, 35)}...`;
    },

    agentOnline() {
      try {
        const agent = this.availableAgents.find((a) => a.agentId === this.conversation.operator_id);
        return !!agent;
      } catch (err) { }
    }
  },
  methods: {
    blinkRecipient(conversationId, onOff) {
      const el = document.querySelector(".phone-label-" + conversationId);
      if (el !== null) {
        el.classList.add("bg-danger");
        if (onOff == "on" && el.classList && !el.classList.contains("blink")) {
          el.classList.add("blink");
        } else if (
          onOff == "off" &&
          el.classList &&
          el.classList.contains("blink")
        ) {
          el.classList.remove("blink");
        }
      }
    },
    prettyRecipientLabel(label) {
      //check if it's phone number or not
      if (/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(label)) {
        return this.prettyPhoneNumber(label);
      }
      return label;
    }
  },
  created() {
    this.receiveGeolocation = false;
    EventBus.$on("AgentAssignedEvent", (conversationId) => {
      this.blinkRecipient(conversationId, "on");
    });
    EventBus.$on("AlertConversation", (conversationId) => {
      if (this.$route.params.conversationId !== conversationId)
        this.blinkRecipient(conversationId, "on");
    });
    EventBus.$on("conversationReadEvent", (conversationId) => {
      this.blinkRecipient(conversationId, "off");
    });
    EventBus.$on("receiveGeolocation", (data) => {
      const { conversation_id } = data;
      if (!this.receiveGeolocation) {
        this.receiveGeolocation = conversation_id === this.conversationId;
      }
    })
  },
};
</script>

<style scoped lang="scss">
/* .filter-green{
    filter: invert(30%) sepia(82%) saturate(4726%) hue-rotate(207deg) brightness(98%) contrast(81%);
} */

.conversation-recipient {
  opacity: 1;

  &.closed-conversation {
    opacity: 0.5;
  }
}

.fa-stack[data-count]:after {
  position: absolute;
  right: 0%;
  top: 1%;
  content: attr(data-count);
  font-size: 30%;
  padding: 0.6em;
  border-radius: 999px;
  line-height: 0.75em;
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 2em;
  font-weight: bold;
}

.blink {
  animation: blinker 1s linear infinite;
  background-color: red;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.convo-selected {
  background-color: lightyellow;
}
</style>
